import _get from 'lodash/get'

export const get_event_audience = state => _get(state, 'audience.event')
export const get_event_audience_gender = state => _get(state, 'audience.event.gender')
export const get_event_audience_psychographics = state => _get(state, 'audience.event.psychographics')
